
<c-row class="justify-content-center mt-4">
  <c-col md="8" lg="7">
    <c-card>
      <c-card-header class="bg-primary text-white">
        <h4 class="mb-0">{{ isEditMode ? 'Edit Client' : 'Add Client' }}</h4>
      </c-card-header>
      <c-card-body>
        <form id="clientForm" (ngSubmit)="onSubmit()" #clientForm="ngForm">
          <c-row class="g-3">
            <c-col md="6">
              <label for="client_code" class="form-label">Client Code <span class="text-danger">*</span></label>
              <input type="text" id="client_code" name="client_code" class="form-control" [(ngModel)]="client.client_code" required [disabled]="isEditMode">
              <div *ngIf="errors['client_code']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['client_code']">{{ msg }}</div>
              </div>
            </c-col>
            <c-col md="6">
              <label for="client_name" class="form-label">Client Name <span class="text-danger">*</span></label>
              <input type="text" id="client_name" name="client_name" class="form-control" [(ngModel)]="client.client_name" required>
              <div *ngIf="errors['client_name']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['client_name']">{{ msg }}</div>
              </div>
            </c-col>
            <c-col md="6">
              <label for="direct_supervisor_name" class="form-label">Direct Supervisor Name <span class="text-danger">*</span></label>
              <input type="text" id="direct_supervisor_name" name="direct_supervisor_name" class="form-control" [(ngModel)]="client.direct_supervisor_name" required>
              <div *ngIf="errors['direct_supervisor_name']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['direct_supervisor_name']">{{ msg }}</div>
              </div>
            </c-col>
            <c-col md="6">
              <label for="website" class="form-label">Website</label>
              <input type="text" id="website" name="website" class="form-control" [(ngModel)]="client.website">
              <div *ngIf="errors['website']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['website']">{{ msg }}</div>
              </div>
            </c-col>
            <c-col md="6">
              <label for="status" class="form-label">Status <span class="text-danger">*</span></label>
              <select id="status" name="status" class="form-select" [(ngModel)]="client.status" required>
                <option value="Great">Great</option>
                <option value="Watch">Watch</option>
                <option value="Newly Onboard">Newly Onboard</option>
                <option value="Disengaged">Disengaged</option>
                <option value="At Risk">At Risk</option>
              </select>
              <div *ngIf="errors['status']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['status']">{{ msg }}</div>
              </div>
            </c-col>
            <c-col md="6">
              <label for="contract_start_date" class="form-label">Contract Start Date</label>
              <input type="date" id="contract_start_date" name="contract_start_date" class="form-control" [(ngModel)]="client.contract_start_date">
              <div *ngIf="errors['contract_start_date']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['contract_start_date']">{{ msg }}</div>
              </div>
            </c-col>
            <c-col md="6">
              <label for="end_of_contract_date" class="form-label">End of Contract Date</label>
              <input type="date" id="end_of_contract_date" name="end_of_contract_date" class="form-control" [(ngModel)]="client.end_of_contract_date">
              <div *ngIf="errors['end_of_contract_date']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['end_of_contract_date']">{{ msg }}</div>
              </div>
            </c-col>
          </c-row>
          <hr>
          <h5 class="mt-3">Primary Contact</h5>
          <c-row class="g-3">
            <c-col md="6">
              <label for="contact_email_primary" class="form-label">Email <span class="text-danger">*</span></label>
              <input type="email" id="contact_email_primary" name="contact_email_primary" class="form-control" [(ngModel)]="client.contact_email_primary" required>
              <div *ngIf="errors['contact_email_primary']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['contact_email_primary']">{{ msg }}</div>
              </div>
            </c-col>
            <c-col md="6">
              <label for="phone_primary" class="form-label">Phone <span class="text-danger">*</span></label>
              <input type="text" id="phone_primary" name="phone_primary" class="form-control" [(ngModel)]="client.phone_primary" required pattern="^[0-9]*$">
              <div *ngIf="errors['phone_primary']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['phone_primary']">{{ msg }}</div>
              </div>
            </c-col>
            <c-col md="6">
              <label for="contact_first_name_primary" class="form-label">First Name <span class="text-danger">*</span></label>
              <input type="text" id="contact_first_name_primary" name="contact_first_name_primary" class="form-control" [(ngModel)]="client.contact_first_name_primary" required>
              <div *ngIf="errors['contact_first_name_primary']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['contact_first_name_primary']">{{ msg }}</div>
              </div>
            </c-col>
            <c-col md="6">
              <label for="contact_last_name_primary" class="form-label">Last Name <span class="text-danger">*</span></label>
              <input type="text" id="contact_last_name_primary" name="contact_last_name_primary" class="form-control" [(ngModel)]="client.contact_last_name_primary" required>
              <div *ngIf="errors['contact_last_name_primary']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['contact_last_name_primary']">{{ msg }}</div>
              </div>
            </c-col>
          </c-row>
          <hr>
          <h5 class="mt-3">Secondary Contact <span class="text-muted">(Optional)</span></h5>
          <c-row class="g-3">
            <c-col md="6">
              <label for="contact_email_secondary" class="form-label">Email</label>
              <input type="email" id="contact_email_secondary" name="contact_email_secondary" class="form-control" [(ngModel)]="client.contact_email_secondary">
              <div *ngIf="errors['contact_email_secondary']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['contact_email_secondary']">{{ msg }}</div>
              </div>
            </c-col>
            <c-col md="6">
              <label for="phone_secondary" class="form-label">Phone</label>
              <input type="text" id="phone_secondary" name="phone_secondary" class="form-control" [(ngModel)]="client.phone_secondary" pattern="^[0-9]*$">
              <div *ngIf="errors['phone_secondary']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['phone_secondary']">{{ msg }}</div>
              </div>
            </c-col>
            <c-col md="6">
              <label for="contact_first_name_secondary" class="form-label">First Name</label>
              <input type="text" id="contact_first_name_secondary" name="contact_first_name_secondary" class="form-control" [(ngModel)]="client.contact_first_name_secondary">
              <div *ngIf="errors['contact_first_name_secondary']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['contact_first_name_secondary']">{{ msg }}</div>
              </div>
            </c-col>
            <c-col md="6">
              <label for="contact_last_name_secondary" class="form-label">Last Name</label>
              <input type="text" id="contact_last_name_secondary" name="contact_last_name_secondary" class="form-control" [(ngModel)]="client.contact_last_name_secondary">
              <div *ngIf="errors['contact_last_name_secondary']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['contact_last_name_secondary']">{{ msg }}</div>
              </div>
            </c-col>
          </c-row>
          <hr>
          <h5 class="mt-3">Timesheet</h5>
          <c-row class="g-3">
            <c-col md="6">
              <label for="email_delivery_method" class="form-label">Email Delivery Method</label>
              <select id="email_delivery_method" name="email_delivery_method" class="form-select" [(ngModel)]="client.email_delivery_method">
                <option value="">— Select —</option>
                <option value="Individual">Individual</option>
                <option value="Bulk">Bulk</option>
                <option value="Do Not Send">Do Not Send</option>
                <option value="Auto Approved">Auto Approved</option>
              </select>
              <div *ngIf="errors['email_delivery_method']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['email_delivery_method']">{{ msg }}</div>
              </div>
            </c-col>
            <c-col md="6" *ngIf="client.email_delivery_method === 'Bulk'">
              <label for="timesheet_link" class="form-label">Timesheet Link</label>
              <input type="text" id="timesheet_link" name="timesheet_link" class="form-control" [(ngModel)]="client.timesheet_link">
              <div *ngIf="errors['timesheet_link']" class="text-danger small mt-1">
                <div *ngFor="let msg of errors['timesheet_link']">{{ msg }}</div>
              </div>
            </c-col>

          </c-row>
        </form>

        <!-- Client Approvers (edit mode only) -->
        <ng-container *ngIf="isEditMode">
          <hr class="mt-4">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h5 class="mb-0">Client Approvers</h5>
            <button type="button" class="btn btn-sm btn-primary" (click)="openAddApprover()" *ngIf="!showApproverForm">
              <c-icon name="cil-plus" size="sm"></c-icon> Add Approver
            </button>
          </div>

          <!-- Inline approver form -->
          <div *ngIf="showApproverForm" class="border rounded p-3 mb-3 bg-light">
            <h6 class="mb-3">{{ editingApprover ? 'Edit Approver' : 'New Approver' }}</h6>
            <form [formGroup]="approverForm" (ngSubmit)="saveApprover()">
              <c-row class="g-3">
                <c-col md="3">
                  <label class="form-label">Title</label>
                  <select class="form-select" formControlName="title">
                    <option value="">—</option>
                    <option value="Mr.">Mr.</option>
                    <option value="Mrs.">Mrs.</option>
                    <option value="Ms.">Ms.</option>
                    <option value="Dr.">Dr.</option>
                    <option value="Engr.">Engr.</option>
                    <option value="Atty.">Atty.</option>
                    <option value="Prof.">Prof.</option>
                    <option value="Rev.">Rev.</option>
                  </select>
                </c-col>
                <c-col md="5">
                  <label class="form-label">First Name <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" formControlName="first_name" placeholder="First name">
                  <div *ngIf="approverForm.get('first_name')?.invalid && approverForm.get('first_name')?.touched" class="text-danger small mt-1">
                    First name is required.
                  </div>
                </c-col>
                <c-col md="4">
                  <label class="form-label">Last Name <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" formControlName="last_name" placeholder="Last name">
                  <div *ngIf="approverForm.get('last_name')?.invalid && approverForm.get('last_name')?.touched" class="text-danger small mt-1">
                    Last name is required.
                  </div>
                </c-col>
                <c-col md="6">
                  <label class="form-label">Email <span class="text-danger">*</span></label>
                  <input type="email" class="form-control" formControlName="email" placeholder="email@example.com">
                  <div *ngIf="approverForm.get('email')?.invalid && approverForm.get('email')?.touched" class="text-danger small mt-1">
                    <span *ngIf="approverForm.get('email')?.errors?.['required']">Email is required.</span>
                    <span *ngIf="approverForm.get('email')?.errors?.['email']">Enter a valid email.</span>
                  </div>
                </c-col>
                <c-col md="6">
                  <label class="form-label">Status <span class="text-danger">*</span></label>
                  <select class="form-select" formControlName="status">
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </c-col>
              </c-row>
              <hr class="mt-3 mb-2">
              <div class="d-flex justify-content-end gap-2">
                <button type="button" class="btn btn-secondary btn-sm" (click)="cancelApproverForm()" [disabled]="savingApprover">Cancel</button>
                <button type="submit" class="btn btn-primary btn-sm" [disabled]="savingApprover">
                  {{ savingApprover ? 'Saving...' : (editingApprover ? 'Update' : 'Add') }}
                </button>
              </div>
            </form>
          </div>

          <!-- Approvers table -->
          <div class="d-flex justify-content-center my-3" *ngIf="loadingApprovers">
            <c-spinner variant="border" label="Loading..."></c-spinner>
          </div>
          <table class="table table-sm table-bordered align-middle" *ngIf="!loadingApprovers && approvers.length > 0">
            <thead class="table-light">
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Title</th>
                <th>Email</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let approver of approvers">
                <td>{{ approver.first_name }}</td>
                <td>{{ approver.last_name }}</td>
                <td>{{ approver.title || '-' }}</td>
                <td>{{ approver.email }}</td>
                <td>
                  <span class="badge" [ngClass]="{'bg-success': approver.status === 'active', 'bg-secondary': approver.status !== 'active'}">
                    {{ approver.status | titlecase }}
                  </span>
                </td>
                <td class="d-flex gap-1">
                  <button class="btn btn-sm btn-outline-secondary" (click)="openEditApprover(approver)" title="Edit">
                    <c-icon name="cil-pencil" size="sm"></c-icon>
                  </button>
                  <button class="btn btn-sm btn-outline-danger" (click)="deleteApprover(approver)" title="Delete">
                    <c-icon name="cil-trash" size="sm"></c-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-muted small" *ngIf="!loadingApprovers && approvers.length === 0 && !showApproverForm">
            No approvers added yet.
          </div>
        </ng-container>

        <div class="mt-4 text-end">
          <button type="submit" form="clientForm" class="btn btn-primary px-4" [disabled]="!clientForm.form.valid">{{ isEditMode ? 'Update' : 'Submit' }}</button>
        </div>

      </c-card-body>
    </c-card>
  </c-col>
</c-row>
